// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { $delete, createOrUpdate, get, list } from "./operations.js";
export {
  GlobalReachConnectionsDeleteOptionalParams,
  GlobalReachConnectionsCreateOrUpdateOptionalParams,
  GlobalReachConnectionsGetOptionalParams,
  GlobalReachConnectionsListOptionalParams,
} from "./options.js";
